import React, { useEffect, useState } from 'react';
import { adminApi, fmtCurrency } from '@/lib/api';
import { useLanguage } from '@/contexts/LanguageContext';
import { Card, CardContent } from '@/components/ui/card';
import { Users, ShieldCheck, ArrowDownToLine, ArrowUpFromLine, Receipt, Building2 } from 'lucide-react';

export default function AdminOverviewPage() {
  const { t } = useLanguage();
  const [kpis, setKpis] = useState(null);

  useEffect(() => { adminApi.get('/admin/overview').then(r => setKpis(r.data)); }, []);

  const cards = [
    { key: 'users_total', label: 'Total users', icon: Users, testid: 'admin-kpi-users' },
    { key: 'users_kyc_pending', label: 'KYC pending', icon: ShieldCheck, testid: 'admin-kpi-pending-kyc' },
    { key: 'users_kyc_approved', label: 'KYC approved', icon: ShieldCheck, testid: 'admin-kpi-kyc-approved' },
    { key: 'pending_deposits', label: 'Deposits pending', icon: ArrowDownToLine, testid: 'admin-kpi-pending-deposits' },
    { key: 'pending_withdrawals', label: 'Withdrawals pending', icon: ArrowUpFromLine, testid: 'admin-kpi-pending-withdrawals' },
    { key: 'total_transactions', label: 'Transactions', icon: Receipt, testid: 'admin-kpi-transactions' },
    { key: 'companies_total', label: 'Companies', icon: Building2, testid: 'admin-kpi-companies' },
    { key: 'companies_pending', label: 'Companies pending', icon: Building2, testid: 'admin-kpi-companies-pending' },
  ];

  return (
    <div className="space-y-6">
      <div><h1 className="font-serif text-3xl text-[hsl(var(--brand-navy-2))]">{t('admin.overview')}</h1></div>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
        {cards.map(c => (
          <Card key={c.key} className="bg-white" data-testid={c.testid}>
            <CardContent className="p-5">
              <div className="flex items-center justify-between">
                <div className="text-xs uppercase tracking-widest text-[hsl(var(--muted-foreground))]">{c.label}</div>
                <c.icon className="h-4 w-4 text-[hsl(var(--brand-navy))]" />
              </div>
              <div className="mt-3 text-3xl font-semibold tabular-nums text-[hsl(var(--brand-navy-2))]">{kpis?.[c.key] ?? 0}</div>
            </CardContent>
          </Card>
        ))}
      </div>
    </div>
  );
}
